import buffer from '@turf/buffer'
import { featureCollection } from '@turf/helpers'
import simplify from '@turf/simplify'
import truncate from '@turf/truncate'
import union from '@turf/union'
import $ from 'jquery'
import isNil from 'lodash/isNil'
import unset from 'lodash/unset'

import * as Model from 'api/model'
import * as PoziUtils from 'api/utils'
import { ShowWhatsHere, UseWhatsHereInfoPanel } from 'drawer/tabs/info/WhatsHereUtils'
import { selectStyle } from 'drawer/tabs/tools/select'
import PoziMap from 'map/map'
import PoziNotifications from 'utils/notifications'
import { targetGet, targetIsset, targetSet } from 'utils/target'

import PoziMeasure from './measure'

/**
 * Pozi MDL Drawer Adapter for info tab
 */
export default function PoziDrawerTabToolsBuffer () {
  // Adapters
  const adapters = {
    init: function () {
      return init()
    },
    go: function () {
      return go()
    }
  }

  const app = PoziUtils.getApp()

  /**
   * Init
   */
  var init = function () {
    const visible = Model.get('config.layout.drawer.tabs.tools.bufferselect.visible', true)
    if (visible) {
      addEvents()
      $('#bufferSelectToolMetres').val(100)
    }
    Model.on('app.drawer.activetabid', (value) => {
      if (value !== 'tools') {
        $('#bufferSelectToolControls').hide()
      }
    })
  }

  const clickBuffer = function (evt) {
    PoziUtils.eventHandled(evt)
    console.log('PoziDrawerTabToolsBuffer: bufferButton clicked')
    PoziUtils.gtag({
      category: 'useraction',
      status: 'success',
      identifier: 'Buffer button',
      action: 'Click buffer button'
    })
    $('#bufferSelectToolControls').show()

    if (targetIsset()) {
      $('#bufferSelectToolInfo').hide()
      $('#bufferSelectToolOptions').show()
    } else {
      $('#bufferSelectToolInfo').show()
      $('#bufferSelectToolOptions').hide()
    }
  }

  var addEvents = function () {
    $('#bufferSelectTool').on('click', clickBuffer)
    $('#bufferSelectToolGo').on('click', go)
  }

  var go = function () {
    console.log('Buffer select: Go...')

    // Hide any previous selections/drawings
    PoziMeasure().clear()

    let featureCollectionT = targetGet()

    if (isNil(featureCollectionT)) {
      console.log('Invalid feature collection.', featureCollectionT)
      PoziNotifications().warning('Please make a selection first.')
      return
    }

    featureCollectionT.features.forEach(function (feature) {
      unset(feature, 'properties')
    })

    const bufferMeters = $('#bufferSelectToolMetres').val()

    featureCollectionT = buffer(featureCollectionT, bufferMeters * 0.001, {
      units: 'kilometers',
      steps: 4
    })

    // https://github.com/Turfjs/turf/issues/742 -- Do not use dissolve for now.
    // var bufferedFeatureCollectionDissolved = dissolve(bufferedFeatureCollection)
    if (featureCollectionT.features.length > 1) {
      const unionT = union.apply(null, featureCollectionT.features)
      featureCollectionT = featureCollection([unionT])
    }

    featureCollectionT = simplify(featureCollectionT, {
      tolerance: 0.000005,
      highQuality: false,
      mutate: true
    })

    featureCollectionT = truncate(featureCollectionT)

    const olLayer = PoziMap().addLayerFromGeoJSON(featureCollectionT)

    // Use select style
    olLayer.setStyle(selectStyle)

    // Use the measure OL layer storage for this layer, so we can
    // clear it.
    Model.set('app.measure.ollayer', olLayer)

    // TODO: Do this when the data returned??
    // window.setTimeout(function () {
    //   PoziMap().fadeOutLayer(olLayer)
    // }, 1000)

    targetSet(featureCollectionT)

    if (UseWhatsHereInfoPanel()) {
      ShowWhatsHere(featureCollectionT)
    } else {
      app.activateMode('default') // Triggers card expansion.
    }
  }

  // Return adapters (must be at end of adapter)
  return adapters
}
